<app-button
    icon="pi-arrows-v"
    [pTooltip]="'entities.history.expand' | translate"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (clickEvent)="expand()"
></app-button>
<app-button
    icon="pi-bars"
    [pTooltip]="'entities.history.collapse' | translate"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (clickEvent)="expand(false)"
></app-button>
<p-tree class="" [value]="tree" [emptyMessage]="'entities.history.noChange' | translate">
    <ng-template let-node pTemplate="default">
        <div class="flex flex-row">
            <b>{{ entityName + '.fields.' + node.label | translate }}</b>
            @if (node.data) {
                <b class="mr-2">:</b>
            }
            @if (!node.isArray) {
                <div class="flex flex-column">
                    <span
                        [ngClass]="{ 'text-success': !node.oldData, 'text-primary': node.oldData }"
                    >
                        {{ node.data }}
                    </span>
                    @if (!node.data) {
                        <span>&nbsp;</span>
                    }
                    @if (node.oldData) {
                        <span [ngClass]="{ 'text-danger': !node.data }">({{ node.oldData }})</span>
                    }
                </div>
            } @else {
                @if (node.isArray) {
                    <div class="flex flex-column">
                        <br/>
                        @for (row of node.data; track $index; let rowIndex = $index) {
                            <div>
                                @if (Array.isArray(row)) {
                                    <div class="flex">
                                        @for (r of row; track $index; let index = $index) {
                                            @if (r._key) {
                                                <ng-container>
                                                    @if (index > 0) {
                                                        <span class="mr-2">,</span>
                                                    }
                                                    <b class="mr-2">{{ r._key | translate }}:</b>
                                                    <span class="flex flex-column">
                                                        <span
                                                            [ngClass]="{ 'text-success': !node.oldData?.[rowIndex]?.[index]?._value, 'text-primary': (node.oldData?.[rowIndex]?.[index]?._value ?? '') }"
                                                        >
                                                            {{ r._value || '-' }}
                                                        </span>
                                                        @let oldValue = node.oldData?.[rowIndex]?.[index]?._value ?? null;
                                                        @if (oldValue) {
                                                            <ng-container>
                                                                @if (r._value != oldValue) {
                                                                    <span>({{ oldValue }})</span>
                                                                }
                                                            </ng-container>
                                                        }
                                                    </span>
                                                </ng-container>
                                            } @else {
                                                <ng-container>{{ r }}</ng-container>
                                            }
                                        }
                                    </div>
                                } @else {
                                    <div class="flex flex-column">
                                        <span
                                            [ngClass]="{ 'text-success': !node.oldData?.[rowIndex], 'text-primary': (node.oldData?.[rowIndex] ?? '') }"
                                        >
                                            {{ row }}
                                        </span>
                                        <span>({{ node.oldData?.[rowIndex] }})</span>
                                    </div>
                                }
                            </div>
                        }

                        <!-- Old data overflowing data.length -->
                        @for (row of node.oldData; track $index; let rowIndex = $index) {
                            @if (rowIndex >= node.data.length) {
                                @if (Array.isArray(row)) {
                                    <div class="flex">
                                        @for (r of row; track $index; let index = $index) {
                                            @if (r._key) {
                                                @if (index > 0) {
                                                    <span class="mr-2">,</span>
                                                }
                                                <b class="mr-2">{{ r._key | translate }}:</b>
                                                <span class="text-danger">
                                                    {{ node.oldData?.[rowIndex]?.[index]?._value }}
                                                </span>
                                            } @else {
                                                <span class="text-danger">{{ r }}</span>
                                            }
                                        }
                                    </div>
                                } @else {
                                    <div class="flex flex-column">
                                        <span class="text-danger">{{ node.oldData?.[rowIndex] }}</span>
                                    </div>
                                }
                            }
                        }
                    </div>
                }
            }
        </div>
    </ng-template>
</p-tree>
